import { render, staticRenderFns } from "./view-leg.vue?vue&type=template&id=7f2d033d&"
import script from "./view-leg.vue?vue&type=script&lang=js&"
export * from "./view-leg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "view-leg.vue"
export default component.exports